// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/model/model.scss
// module id = 1359
// module chunks = 10